<template>
  <div class="navbar">
    <div class="flex navbar-content" align="right">
      <div class="flex" style="align-items: center">
        <i
          class="el-icon-arrow-left"
          style="font-size: 24px; cursor: pointer; margin-right: 10px"
          title="back"
          @click="goBack"
          v-if="hasBack"
        ></i>
        <img
          src="../../assets/img/kssd-logo.png"
          @click="goHome"
          class="logo"
          alt=""
        />
        <span @click="goHome">KSSD</span>
      </div>
      <div v-if="hasRight">
        <slot name="right">
          <el-button type="text" @click="goLicense">License</el-button>
          <el-button type="text" @click="goAbout">About</el-button>
          <el-button type="text" @click="goSetting">Setting</el-button>
          <el-button type="text" @click="goDownloadInstall">Download</el-button>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 有返回功能
    hasBack: {
      default () {
        return false
      }
    },
    hasRight: {
      default () {
        return true
      }
    }
  },
  methods: {
    goBack () {
      if (this.hasBack) {
        this.$router.back()
      }
    },
    goLicense () {
      this.$router.push('/license')
    },
    goDownloadClient () {
      this.$router.push('/DownloadClient')
    },
    goSetting () {
      this.$router.push('setting')
    },
    goAbout () {
      this.$router.push('brief')
    },
    goDownloadInstall () {
      this.$router.push('downloadInstall')
    },
    goHome () {
      if (this.hasBack) {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.navbar {
  position: relative;
  min-height: 50px;
  border-radius: 0px;
  box-shadow: rgb(153 153 153) 0px 1px 5px;
  z-index: 1;
  border: 0px;
  margin-bottom: 21px;
  padding: 0 60px;
}
.navbar-content {
  max-width: 1170px;
  margin: auto;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}
.logo {
  width: 40px;
  height: 40px;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue